import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";

export default function WritingPreviewHeader({
	url,
	status,
	statusLabel,
	isProcessing,
	onRegenerate,
}) {
	const navigate = useNavigate();
	const isCompleted = status === "completed";

	return (
		<div className="writing-preview__header">
			<div className="writing-preview__header-left">
				<button
					type="button"
					className="writing-preview__back"
					onClick={() => navigate("/aivisibility/writing-assistance")}
				>
					<i className="fas fa-arrow-left me-2" />
					Back
				</button>
				{url && (
					<a
						href={url}
						target="_blank"
						rel="noopener noreferrer"
						className="writing-preview__header-url"
						title={url}
					>
						{url}
					</a>
				)}
			</div>
			<div className="writing-preview__header-actions">
				<Button
					color="light"
					className="writing-preview__regenerate-btn border"
					disabled={isProcessing}
					onClick={onRegenerate}
				>
					<i className="fas fa-sync-alt me-2" />
					Regenerate
				</Button>
				{statusLabel && (
					<span
						className={`writing-preview__status-badge ${
							isCompleted ? "writing-preview__status-badge--ready" : ""
						}`}
					>
						{isCompleted && <i className="fas fa-check-circle me-1" />}
						{statusLabel}
					</span>
				)}
			</div>
		</div>
	);
}
